import React from 'react';

const MyDetailsBar = () => {
    return (
        <div className=" hidden sm:flex flex-row gap-6 2xl:gap-12 px-6 text-white text-sm md:text-base 2xl:text-lg my-6 ">
            <div>My Details</div>
            {/*<div className={`opacity-40`}>Kipometer</div>*/}
            {/*<div className={`opacity-40`}>Saved Content</div>*/}
            {/*<div className={`opacity-40`}>Alerts/Messsages</div>*/}
            {/*<div className={`opacity-40`}>Contact Us</div>*/}
            {/*<div className={`opacity-40`}>Help</div>*/}
        </div>
    );
};

export default MyDetailsBar;
